export default __webpack_public_path__ + "static/media/101.955f0d9f.png";